import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

/**
 * Create a new Order.
 *
 * @private
 */
export const createOrder = createAsyncThunk<
  // Return type of the payload creator
  string[],
  // First argument to the payload creator
  uui.domain.ui.forms.OrderCreate,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/order/create', async (order, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const response = await rpc('rpc/order/create', {
      category: 'rpc',
      type: 'rpc/order/create',
      order,
    })

    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }

    return response.result
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {createOrder}`,
      { tags: ['rpc', 'order'], info: order },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Create ${order.orderTemplate.name} Failed`,
      error,
    })
  }
})
